import { render, staticRenderFns } from "./brandList.vue?vue&type=template&id=7b9526d4&scoped=true"
import script from "./brandList.vue?vue&type=script&lang=js"
export * from "./brandList.vue?vue&type=script&lang=js"
import style0 from "./brandList.vue?vue&type=style&index=0&id=7b9526d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9526d4",
  null
  
)

export default component.exports